import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";
import { useGetVendorId } from "../../hooks/global/User";
import api from '../../services/api';

const empty = {
    id: "",
    name: "",
    texts: {
        emailSubject: "",
        emailSender: "",
        emailParagraph: "",
        reviewTitle: ""
    },
    internal: false,
    descriptive_name: "",
    display_element_details: false,
    show_prize_game: true,
    question_ids: null,
    vendor_id: "",
}

export const useGetEmptyModule = () => {
    return {...empty}
}

export const useGetModules = (e=true) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } =  await api.get(`${process.env.REACT_APP_API_URL}/modules/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['modules'], queryFn: fetchData, enabled: e });
};


export const useGetModule = (moduleId) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } = (moduleId) ? await api.get(`${process.env.REACT_APP_API_URL}/modules/${moduleId}/?vendorId=${vendorId}`) : { data: {...empty} }
        return data;
    };
    return useQuery({ queryKey: ['module', moduleId], queryFn: fetchData, enabled: true });
};


export const useGetModuleData = (moduleId, companyId) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return companyId ? useGetCompanyModuleData(companyId) : useGetModule(moduleId);
};


export const useGetCompanyModule = (e = true) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } =  await api.get(`${process.env.REACT_APP_API_URL}/modules/company/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['companyModule'], queryFn: fetchData, enabled: e });
};

export const useGetCompanyModuleData = (companyId) => {
    const vendorId = useGetVendorId();
    const fetchData = async () => {
        const { data } =  await api.get(`${process.env.REACT_APP_API_URL}/modules/company/${companyId}/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['companyModuleData', companyId], queryFn: fetchData, enabled: true });
};

export const useUpdateModule = (moduleId) => {
    const vendorId = useGetVendorId();
    const queryClient = useQueryClient();
    const updateData = async ({data:updateData, message=null}) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/modules/${moduleId}/?vendorId=${vendorId}`, updateData)     
        success(message);   
        return data;
    };
    return useMutation(updateData, {
        onSuccess: (data) => {
            queryClient.invalidateQueries(['questions', moduleId]);
        },
    })
};

export const useUpdateCompanyModule = (companyId) => {
    const vendorId = useGetVendorId();
    const queryClient = useQueryClient();
    const updateData = async ({data:updateData, message=null}) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/modules/company/${companyId}/?vendorId=${vendorId}`, updateData)     
        success(message);   
        return data;
    };
    return useMutation(updateData, {
        onSuccess: (data) => {
            queryClient.invalidateQueries(['companyModuleData', companyId]);
        },
    })
};

export const useInsertModule = () => {
    const vendorId = useGetVendorId();
    const queryClient = useQueryClient();
    const insertData = async ({data:insertData, message=null}) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/modules/?vendorId=${vendorId}`, insertData);
        queryClient.invalidateQueries(['modules']);
        success(message);
        return data;
    };

    return useMutation(insertData);
};
